import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const previewSrc = (p) =>
  !p ? "" : p.startsWith("http") ? p : `${API}/files/preview?path=${encodeURIComponent(p)}`;

export const fmt = (cents, currency = "USD") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency }).format((cents || 0) / 100);

export const CATEGORY_LABELS = {
  study: "Study Planners",
  budget: "Budget Planners",
  habits: "Habit Trackers",
  templates: "Editable Templates",
};

export const IMAGES = {
  heroFlatlay:
    "https://images.unsplash.com/photo-1551042686-e9c5f4e230cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxhZXN0aGV0aWMlMjBwbGFubmVyJTIwam91cm5hbCUyMHdvcmtzcGFjZXxlbnwwfHx8fDE3ODMzOTAzNDB8MA&ixlib=rb-4.1.0&q=85",
  heroTablet: "https://images.pexels.com/photos/768473/pexels-photo-768473.jpeg",
  workspace: "https://images.pexels.com/photos/8386570/pexels-photo-8386570.jpeg",
  study:
    "https://images.pexels.com/photos/5185075/pexels-photo-5185075.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  budget:
    "https://images.unsplash.com/photo-1615826932727-ed9f182ac67e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHxfHxhZXN0aGV0aWMlMjBwbGFubmVyJTIwam91cm5hbCUyMHdvcmtzcGFjZXxlbnwwfHx8fDE3ODMzOTAzNDB8MA&ixlib=rb-4.1.0&q=85",
  habits: "https://images.unsplash.com/photo-1514782831304-632d84503f6f",
  templates: "https://images.unsplash.com/photo-1669691082535-da2bc1e1094f",
};

export function formatApiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
}

export async function adminCall(fn) {
  try {
    return await fn();
  } catch (e) {
    if (e?.response?.status === 401) {
      try {
        await api.post("/auth/refresh");
        return await fn();
      } catch {
        window.location.href = "/admin/login";
        return new Promise(() => {});
      }
    }
    throw e;
  }
}
